<template>
  <div>
    <template v-if="items.length === 0">
      <v-layout class="mt-3 px-8">
        <v-flex xs12>
          <v-card class="pb-4 rounded-10 elevation-card">
            <v-card-title class="primary pa-2 white--text">
              <span id="titleBrand" class="title pl-2"></span>
              <v-spacer></v-spacer>
              <v-icon class="mr-4" color="white" id="removeBudget">
                keyboard_arrow_down
              </v-icon>
              <v-icon
                color="white"
                class="mr-2"
                id="refreshBudget"
                @click="getData()"
                >refresh</v-icon
              >
            </v-card-title>
            <v-card-text class="pa-3">
              <v-layout row wrap class>
                <v-flex xs12 class="py-0 pt-4 text-center">
                  No data displayed
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
    <v-layout
      v-else
      row
      wrap
      class="pt-5 px-10"
      v-for="(itemCard, indexCard) in items"
      :key="'itemcard' + indexCard"
    >
      <span
        class="font-weight-700 fs-20 lh-16 pl-1 bluedarken--text"
        style="align-self: center"
      >
        {{ itemCard.name }}
      </span>
      <v-spacer></v-spacer>
      <v-flex
        xs3
        class="text-right pa-0"
        v-if="
          hasPermission('create_spending', 'create') &&
            page == 'report' &&
            !itemCard.submitable
        "
      >
        <v-chip
          v-if="itemCard.status === 'draft' || itemCard.status === 'to modify'"
          color="grey"
          class="white--text mr-4 text-uppercase"
        >
          {{ itemCard.status ? itemCard.status : '-' }}
        </v-chip>
        <v-chip
          v-else-if="itemCard.status === 'approved'"
          color="teal"
          class="white--text mr-4 text-uppercase"
        >
          {{ itemCard.status ? itemCard.status : '-' }}
        </v-chip>
        <v-chip
          v-else-if="itemCard.status === 'rejected'"
          color="red"
          class="white--text mr-4 text-uppercase"
        >
          {{ itemCard.status ? itemCard.status : '-' }}
        </v-chip>
        <v-chip
          v-else-if="itemCard.status === 'approval process'"
          color="thirdblue"
          class="white--text mr-4 text-uppercase"
        >
          {{ itemCard.status ? itemCard.status : '-' }}
        </v-chip>
      </v-flex>
      <v-icon
        color="bluedarken"
        style="font-size: 22px !important"
        id="refreshBudget"
        @click="getData()"
      >
        refresh
      </v-icon>
      <!-- card amount -->
      <v-flex xs12 class="pa-0 pt-2">
        <v-row class="spending-info pa-0">
          <v-col cols="12" sm="6" md="4">
            <card-amount
              colour="softGreen"
              :typeCard="1"
              :value1="itemCard.totalBudget"
              :valueEur="itemCard.totalBudgetEuro"
              text="BUDGET"
              textColor="softGreen--text"
            ></card-amount>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <card-amount
              colour="softRed"
              textColor="softRed--text"
              :typeCard="2"
              :value1="itemCard.totalSpending"
              :valueTotal="itemCard.totalBudget"
              :valueEur="itemCard.totalSpendingEuro"
              text="SPENDING IO"
            ></card-amount>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <card-amount
              colour="bluePurple"
              textColor="bluePurple--text"
              :typeCard="3"
              :value1="itemCard.remaining"
              :valueTotal="itemCard.totalBudget"
              :valueEur="itemCard.remainingEuro"
              text="REMAINING"
            ></card-amount>
          </v-col>
        </v-row>
      </v-flex>
      <!-- /card amount -->

      <!-- expand card yang isinya tab -->
      <v-flex xs12 class="mt-2">
        <v-card flat tile style="background: transparent !important">
          <v-card-text class="px-0">
            <v-expansion-panels width="100%" v-model="itemCard.panel">
              <v-expansion-panel
                @click="getTable(itemCard, itemCard, null)"
                class="mb-5 rounded-10 elevation-card"
                width="100%"
              >
                <v-expansion-panel-header
                  expand-icon="keyboard_arrow_down"
                  class="
                    white
                    bluedarken--text
                    pr-5
                    pl-0
                    py-0
                    rounded-bottom-left-10 rounded-bottom-right-10
                  "
                >
                  <template v-slot:actions>
                    <v-icon
                      color="bluedarken"
                      style="font-size: 23px !important"
                    >
                      keyboard_arrow_down
                    </v-icon>
                  </template>
                  <template>
                    <v-row no-gutters>
                      <div>
                        <img
                          src="@/assets/images/icon/file-text-blue.png"
                          class="mt-1"
                          style="margin-left: 13.2px !important"
                          width="20px"
                        />
                      </div>
                      <span
                        v-if="page !== 'budgeting'"
                        class="
                          pl-2
                          font-weight-bold
                          fs-14
                          bluedarken--text
                          align-self-center
                          text-capitalize
                        "
                      >
                        <!-- {{
                          isLoggedInAsBO
                            ? 'Spending by Taxonomy'
                            : itemGroup[0].filterBy === 'budgetOwner'
                            ? !itemGroup[0].submitable
                              ? 'Progress Tracking'
                              : 'Group'
                            : 'Group'
                        }} -->
                        {{ cardName(itemGroup[0]) }}
                      </span>
                      <span
                        v-else
                        class="
                          pl-2
                          font-weight-bold
                          fs-14
                          bluedarken--text
                          align-self-center
                          text-capitalize
                        "
                      >
                        {{ isLoggedInAsBO ? 'Budget Report' : 'Group' }}
                      </span>
                    </v-row>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0">
                  <v-card-text class="px-0 py-2">
                    <!-- tab level -->
                    <v-tabs
                      v-model="itemCard.tab"
                      background-color="white"
                      color="menuActive"
                      v-if="!isLoggedInAsBO && itemCard.type !== 'budgetOwner'"
                    >
                      <v-tabs-slider></v-tabs-slider>
                      <v-tab
                        v-for="(group, indexTab) in itemCard.group"
                        :key="'group' + indexTab"
                        @click="getTable(itemCard, itemCard, indexTab)"
                        class="text-left px-0 d-block pt-3 mr-10"
                        style="min-width: 100px !important; height: 100%"
                      >
                        <span
                          class="
                            text-capitalize
                            fs-12
                            font-weight-600
                            text-left
                          "
                        >
                          {{ group.name }}
                        </span>
                      </v-tab>
                      <v-tabs-items v-model="itemCard.tab" class="tab-content">
                        <v-tab-item
                          v-for="(tabcontent, indexTab2) in itemCard.group"
                          :key="'tabcontent' + indexTab2"
                        >
                          <template
                            v-for="(listGroup,
                            indexGroup) in tabcontent.listGroup"
                          >
                            <table-group
                              v-if="listGroup.name !== 'Spending by Taxonomy'"
                              :key="listGroup.id"
                              :page="page"
                              :group="listGroup"
                              :listGroup="tabcontent"
                              :year="year"
                              :groupActive="
                                tabcontent.listGroup[indexGroup + 1]
                                  ? tabcontent.listGroup[indexGroup + 1]
                                      .groupActive
                                  : 0
                              "
                              class="mb-8"
                              @getDetailSpending="
                                getDetailSpending(
                                  $event,
                                  itemCard,
                                  indexTab2,
                                  indexGroup
                                )
                              "
                              @getData="getData"
                              @parseParamBudget="parseParamBudget"
                            />
                            <!-- <span :key="listGroup.id" v-else
                              >{{listGroup}}</span
                            > -->
                            <table-io
                              :key="listGroup.id"
                              v-else
                              :dataItem="listGroup"
                              :page="page"
                              :year="year"
                              @getData="getData"
                              class="mb-3"
                              :status="itemCard.status"
                              :submitableDiv="listGroup.single_flow"
                              :filterBy="itemGroup[0].filterBy"
                            />
                          </template>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-tabs>
                    <!-- bo langsung ke tab io -->
                    <template
                      v-else-if="
                        itemCard.group.length > 0 && page !== 'budgeting'
                      "
                    >
                      <table-io
                        v-for="(groupio, indexTab) in itemCard.group[0]
                          .listGroup"
                        :key="'groupio' + indexTab"
                        :dataItem="groupio"
                        class="mb-3"
                        :year="year"
                        @getData="getData"
                        :status="itemCard.status"
                        :submitableDiv="groupio.single_flow"
                        :filterBy="itemGroup[0].filterBy"
                        :page="page"
                      />
                    </template>
                    <template v-else-if="itemCard.group.length > 0">
                      <table-group
                        v-for="(listGroup, indexTab) in itemCard.group[0]
                          .listGroup"
                        :key="'listGroup' + indexTab"
                        :listGroup="tabcontent"
                        :page="page"
                        :group="listGroup"
                        :year="year"
                        class="mb-8"
                        @getData="getData"
                        @parseParamBudget="parseParamBudget"
                      />
                    </template>
                  </v-card-text>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>
        </v-card>
      </v-flex>
      <!-- /expand card yang isinya tab -->
    </v-layout>
    <progress-dialog
      :show="progressDialogLoading"
      text="Please wait"
    ></progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '@/components/progress_dialog';
import cardAmount from '@/components/cardAmount';
import TableGroup from '@/components/SpendingReport/TableGroup';
import TableIO from '@/components/SpendingReport/TableIO';
import LoginAsMixin from '@/mixins/LoginAsMixin';
import moment from 'moment';
import Swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import ACLMixin from '@/mixins/ACLMixin';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    'card-amount': cardAmount,
    'table-group': TableGroup,
    'table-io': TableIO
  },
  mixins: [LoginAsMixin, ACLMixin],
  props: {
    itemGroup: {
      type: Array
    },
    page: {
      type: String
    },
    year: {
      type: Date
    },
    fromDetail: {
      type: String
    },
    ioNumber: {
      type: String
    }
  },
  data() {
    return {
      progressDialogLoading: false,
      panel: false,
      items: [],
      tempParams: [],
      searchBudget: [],
      tempEvent: '',
      tempParent: {},
      tempTab: {},
      tempGroup: [],
      sortColumn: '',
      sortType: ''
    };
  },
  computed: {
    ...mapGetters('auth', ['userMapping'])
  },
  mounted() {},
  watch: {
    itemGroup: {
      handler(newVal) {
        this.items = newVal;
      },
      deep: true,
      immediate: true
    },
    tempParams: {
      handler: function(val) {
        localStorage.setItem('prevIO', JSON.stringify(val));
      },
      deep: true
    }
  },
  methods: {
    cardName(item) {
      return this.isLoggedInAsBO || item.submitable
        ? 'Spending by Taxonomy'
        : item.filterBy === 'budgetOwner'
        ? !item.submitable
          ? 'Progress Tracking'
          : 'Group'
        : 'Group';
      // if (this.isLoggedInAsBO || item.submitable) {
      //   return 'Spending by Taxonomy';
      // } else if (!item.submitable) {
      //   return 'Progress Tracking';
      // } else {
      //   return 'Group';
      // }
    },
    parseParamBudget(obj) {
      this.searchBudget = [];
      switch (obj.type) {
        case 'sort':
          this.sortColumn = obj.param.fieldName;
          this.sortType = obj.param.value;
          break;
        case 'search':
        case 'check':
          if (obj.param.value.length > 0) {
            this.searchBudget[obj.param.index] = obj.param.value;
          }
          break;
      }
      this.getBudget(
        this.tempEvent,
        this.tempParent,
        this.tempTab,
        this.tempGroup
      );
    },
    getData() {
      this.$emit('getData');
    },
    async getTable(item, itemParent, indexTab) {
      // for one pager
      // if (this.fromDetail == 'true') {
      //   tabActive = item.indexTab;
      //   if (item.groupType === 'level') {
      //     await this.getLevels(item);
      //   } else if (
      //     item.groupType !== 'Budget Owner' &&
      //     item.groupType !== 'level'
      //   ) {
      //     await this.getDetailSpending(item);
      //   } else {
      //     await this.getIO(item);
      //   }
      // } else {
      // }

      let tabActive = indexTab ? indexTab : 0;
      // if di divisi ini belum ada group maka nembak getLevels
      if (item.group.length == 0) {
        // get levels ini untuk ambil data buat tab
        await this.getLevels(item);
      }
      if (item.type !== 'budgetOwner') {
        // if di group tersebut belum ada datanya, maka nembak getDetailSpending
        if (
          this.fromDetail == 'true' ||
          item.group[tabActive].listGroup.length == 0
        ) {
          this.getDetailSpending(item, itemParent, tabActive);
        }
      } else {
        // if login bo langsung nembak api io
        if (this.page === 'budgeting') {
          if (item.group[tabActive].listGroup.length == 0) {
            this.getBudget(item, itemParent, tabActive, 0);
          }
        } else {
          if (item.group[tabActive].listGroup.length == 0) {
            this.getIO(item, itemParent);
          }
        }
      }
    },
    getDetailSpending(item, itemParent, indexTab, indexGroup) {
      if (item.type.toLowerCase() === 'budget owner') {
        if (this.page === 'budgeting') {
          this.getBudget(item, itemParent, indexTab, indexGroup);
        } else {
          this.getIO(item, itemParent, indexGroup);
        }
      } else {
        // for back one pager
        // let params = {};
        // if (this.fromDetail == 'true') {
        //   params = item;
        // } else {
        //   }

        this.progressDialogLoading = true;
        let type = this.page;
        let params = {
          type: type,
          profileId: localStorage.getItem('profile_id'),
          year: moment(this.year).format('YYYY'),
          parent_id:
            item.type == 'Group'
              ? item.parent_id
              : item.type == 'division'
              ? null
              : item.id,
          division_id: item.type == 'division' ? item.id : itemParent.id,
          level: item.group ? item.group[indexTab].level : null,
          house_id: item.house_id ? item.house_id : null,
          house_ids: itemParent.house_ids ? itemParent.house_ids : null
        };
        return this.$store
          .dispatch('spendingDynamic/getDetailReport', params)
          .then(data => {
            this.progressDialogLoading = false;
            if (data.code === 200) {
              // for one pager
              // let indexCard =
              //   this.fromDetail == 'true'
              //     ? item.indexCard
              //     : itemParent.indexCard;
              // let idxGroup =
              //   this.fromDetail == 'true' ? item.indexGroup : indexGroup;
              // let idxTab = this.fromDetail == 'true' ? item.indexTab : indexTab;
              // let groupActive =
              //   this.fromDetail == 'true' ? item.groupActive : item.id;
              // let idCard =
              //   this.fromDetail == 'true' ? item.idCard : itemParent.id;

              // cari index card (divisi)
              let indexCard = itemParent.indexCard;
              let idxGroup = indexGroup;
              let idxTab = indexTab;
              let idCard = itemParent.id;
              let house_id = null;
              let groupActive = null;
              if (item.type === 'House') {
                house_id = item.house_id ? item.house_id : item.id;
                groupActive = item.house_id ? item.house_id : item.id;
              } else {
                house_id = item.id;
                groupActive = item.id;
              }

              if (idxGroup >= 0) {
                // hapus group dibawahnya
                let listgroup = this.items[indexCard].group[
                  idxTab
                ].listGroup.slice(0, idxGroup + 1);
                this.items[indexCard].group[idxTab].listGroup = listgroup;
              }
              // push group baru
              this.items[indexCard].group[idxTab].listGroup.push({
                name: data.data.name,
                selectAll: false,
                groupActive: groupActive,
                house_id: house_id,
                idCard: idCard,
                selected: [],
                children: data.data.groups
              });
              // for back one pager
              if (this.fromDetail == 'false') {
                // params.flag = item.type + itemParent.id;
                // params.groupType = item.type;
                // params.groupActive = groupActive;
                // params.indexTab = idxTab;
                // params.indexCard = indexCard;
                // params.indexGroup = idxGroup;
                // let findDuplicate = null;
                // if (this.tempParams.length > 0) {
                //   findDuplicate = this.tempParams.find(
                //     val => val.flag === params.flag
                //   );
                // }
                // if (findDuplicate) {
                //   let indexDuplicate = this.tempParams.findIndex(
                //     val => val.flag === findDuplicate.flag
                //   );
                //   this.tempParams[indexDuplicate] = params;
                // } else {
                //   this.tempParams.push(params);
                // }
                localStorage.setItem('prevFilter', JSON.stringify(this.items));
              }
            } else {
              if (data) {
                Swal.fire(
                  'Failed!',
                  data.response.data.message.text_en,
                  'error'
                );
              } else {
                Swal.fire('Failed!', 'Please try again', 'error');
              }
            }
          })
          .catch(err => {
            this.progressDialogLoading = false;
            Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          });
      }
    },
    getIO(item, itemParent, indexGroup) {
      this.progressDialogLoading = true;
      // for one pager
      let prevIO = JSON.parse(localStorage.getItem('prevIO')) || [];
      let params = {};
      let fromDetail = prevIO.length > 0 && itemParent == 'true';
      if (prevIO.length > 0 && itemParent == 'true') {
        params = item;
      } else {
        let type = this.page !== 'approval' ? 'report' : 'approval';
        params = {
          searched: this.ioNumber ? this.ioNumber : null,
          type: type,
          profileId: localStorage.getItem('profile_id'),
          budgetCode: item.budgetCode,
          divisionId:
            item.type == 'division'
              ? item.id
              : this.isLoggedInAsBO
              ? this.userMapping.divisi_id
              : itemParent.filterBy == 'budgetOwner'
              ? itemParent.division_id
              : itemParent.id
        };
      }
      return this.$store
        .dispatch('spendingDynamic/getIO', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            // for one pager
            // cari index card (divisi)
            let indexCard = fromDetail ? item.indexCard : itemParent.indexCard;
            let idxGroup = fromDetail ? item.indexGroup : indexGroup;
            let tab = fromDetail ? item.tab : itemParent.tab;
            let groupActive = fromDetail ? item.groupActive : item.id;
            let idCard = fromDetail ? item.idCard : itemParent.id;

            if (this.isLoggedInAsBO) {
              // login as bo ga ada tab
              this.items[indexCard].group[0].listGroup = [];
            } else if (idxGroup >= 0) {
              // cek kalo group tadi sudah ada maka group yang lainnya dihapus
              let listgroup = [];
              listgroup = this.items[indexCard].group[tab].listGroup.slice(
                0,
                idxGroup + 1
              );
              this.items[indexCard].group[tab].listGroup = listgroup;
            }
            // push io
            if (this.isLoggedInAsBO) {
              this.items[indexCard].group[0].listGroup.push({
                name: 'Spending by Taxonomy',
                selectAll: false,
                groupActive: groupActive,
                idCard: idCard,
                selected: [],
                submitable: data.data.submitable,
                single_flow: data.data.single_flow,
                header: data.data.header,
                stepItem: data.data.stepItem,
                children: data.data.result
                  ? data.data.result.map(itemsIO => {
                      var result = {};
                      var resultGroup = {};
                      // ubah array of object jadi object
                      for (var a = 0; a < itemsIO.amount.length; a++) {
                        result[itemsIO.amount[a].title] = Number(
                          itemsIO.amount[a].value
                        );
                      }
                      for (var b = 0; b < itemsIO.group.length; b++) {
                        resultGroup[itemsIO.group[b].title.name] =
                          itemsIO.group[b].value;
                      }
                      //handle taxo null
                      if (!itemsIO.taxonomy) {
                        itemsIO.taxonomy = {
                          code: null,
                          pctr: null,
                          mat_group: null,
                          ar1: null,
                          bpc: null,
                          desc: null,
                          code_cost_element: null,
                          code_cost_center: null,
                          costElement: {
                            desc: null,
                            code: null
                          },
                          costCenter: {
                            desc: null,
                            code: null,
                            costNature: {
                              nature_activity: null,
                              category: null,
                              code_cost_center: null
                            }
                          }
                        };
                      }
                      //handle costCenter null
                      if (!itemsIO.taxonomy.costCenter) {
                        itemsIO.taxonomy.costCenter = {
                          desc: null,
                          code: null,
                          costNature: {
                            nature_activity: null,
                            category: null,
                            code_cost_center: null
                          }
                        };
                      }
                      //handle costElement null
                      if (!itemsIO.taxonomy.costElement) {
                        itemsIO.taxonomy.costElement = {
                          desc: null,
                          code: null
                        };
                      }
                      // handle CostNature null
                      if (!itemsIO.taxonomy.costCenter) {
                        if (!itemsIO.taxonomy.costCenter.costNature) {
                          itemsIO.taxonomy.costCenter.costNature = {
                            nature_activity: '-',
                            category: null,
                            code_cost_center: null
                          };
                        }
                      }
                      return {
                        dateStart: this.formatDate(itemsIO.start),
                        dateEnd: this.formatDate(itemsIO.end),
                        channel: this.isLoggedInAsSales
                          ? itemsIO.ioAccount.length > 0
                            ? itemsIO.channels.map(val => val.name).toString()
                            : '-'
                          : '-',
                        account: this.isLoggedInAsSales
                          ? itemsIO.ioAccount.length > 0
                            ? Array.prototype.map
                                .call(itemsIO.ioAccount, s => s.account.name)
                                .toString()
                            : '-'
                          : '-',
                        result,
                        resultGroup,
                        ...itemsIO
                      };
                    })
                  : []
              });
            } else {
              let idxTab = tab ? tab : 0;
              this.items[indexCard].group[idxTab].listGroup.push({
                name: 'Spending by Taxonomy',
                selectAll: false,
                groupActive: groupActive,
                idCard: idCard,
                selected: [],
                submitable: data.data.submitable,
                single_flow: data.data.single_flow,
                header: data.data.header,
                stepItem: data.data.stepItem,
                children: data.data.result
                  ? data.data.result.map(itemsIO => {
                      var result = {};
                      var resultGroup = {};
                      // ubah array of object jadi object
                      for (var a = 0; a < itemsIO.amount.length; a++) {
                        result[itemsIO.amount[a].title] = Number(
                          itemsIO.amount[a].value
                        );
                      }
                      for (var b = 0; b < itemsIO.group.length; b++) {
                        resultGroup[itemsIO.group[b].title.name] =
                          itemsIO.group[b].value;
                      }
                      //handle taxo null
                      if (!itemsIO.taxonomy) {
                        itemsIO.taxonomy = {
                          code: null,
                          pctr: null,
                          mat_group: null,
                          ar1: null,
                          bpc: null,
                          desc: null,
                          code_cost_element: null,
                          code_cost_center: null,
                          costElement: {
                            desc: null,
                            code: null
                          },
                          costCenter: {
                            desc: null,
                            code: null,
                            costNature: {
                              nature_activity: null,
                              category: null,
                              code_cost_center: null
                            }
                          }
                        };
                      }
                      //handle costCenter null
                      if (!itemsIO.taxonomy.costCenter) {
                        itemsIO.taxonomy.costCenter = {
                          desc: null,
                          code: null,
                          costNature: {
                            nature_activity: null,
                            category: null,
                            code_cost_center: null
                          }
                        };
                      }
                      //handle costElement null
                      if (!itemsIO.taxonomy.costElement) {
                        itemsIO.taxonomy.costElement = {
                          desc: null,
                          code: null
                        };
                      }
                      // handle CostNature null
                      if (!itemsIO.taxonomy.costCenter) {
                        if (!itemsIO.taxonomy.costCenter.costNature) {
                          itemsIO.taxonomy.costCenter.costNature = {
                            nature_activity: '-',
                            category: null,
                            code_cost_center: null
                          };
                        }
                      }
                      return {
                        dateStart: this.formatDate(itemsIO.start),
                        dateEnd: this.formatDate(itemsIO.end),
                        channel: this.isLoggedInAsSales
                          ? itemsIO.ioAccount.length > 0
                            ? itemsIO.channels.map(val => val.name).toString()
                            : '-'
                          : '-',
                        account: this.isLoggedInAsSales
                          ? itemsIO.ioAccount.length > 0
                            ? Array.prototype.map
                                .call(itemsIO.ioAccount, s => s.account.name)
                                .toString()
                            : '-'
                          : '-',
                        result,
                        resultGroup,
                        ...itemsIO
                      };
                    })
                  : []
              });
              this.items[indexCard].panel = 0;
            }

            // for back one pager
            if (this.fromDetail == 'false') {
              params.flag = item.type + itemParent.id;
              params.groupType = item.type;
              params.indexCard = indexCard;
              params.indexGroup = idxGroup;
              params.tab = tab;
              params.groupActive = groupActive;
              params.idCard = idCard;
              let findDuplicate = null;
              if (this.tempParams.length > 0) {
                findDuplicate = this.tempParams.find(
                  val => val.flag === params.flag
                );
              }
              if (findDuplicate) {
                let indexDuplicate = this.tempParams.findIndex(
                  val => val.flag === findDuplicate.flag
                );
                this.tempParams[indexDuplicate] = params;
              } else {
                this.tempParams.push(params);
              }
              localStorage.setItem('prevFilter', JSON.stringify(this.items));
              localStorage.setItem('prevIO', JSON.stringify(this.tempParams));
            }
          } else {
            if (data) {
              Swal.fire('Failed!', data.response.data.message.text_en, 'error');
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    getLevels(item) {
      this.progressDialogLoading = true;
      let params = {
        parent_id: item.parent_id || null,
        division_id:
          item.type.toLowerCase() === 'budgetowner' ? item.division_id : item.id
      };
      localStorage.setItem('prevFilter', JSON.stringify(this.items));
      return this.$store
        .dispatch('spendingDynamic/getLevel', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            this.items[item.indexCard].group = data.data;
            let group = this.items[item.indexCard].group.map(val => {
              return {
                ...val,
                listGroup: []
              };
            });
            this.items[item.indexCard].group = group;
          } else {
            if (data) {
              Swal.fire(
                'Failed!',
                data.response.data.data.message.text_en,
                'error'
              );
            } else {
              Swal.fire('Failed!', 'Please try again', 'error');
            }
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    getBudget(event, itemParent, indexTab, indexGroup) {
      this.tempEvent = event;
      this.tempParent = itemParent;
      this.tempTab = indexTab;
      this.tempGroup = indexGroup;
      this.progressDialogLoading = true;
      let params = {
        profileId: localStorage.getItem('profile_id'),
        year: moment(this.year).format('YYYY'),
        budgetCode: event.budgetCode,
        filter: {
          budgetAmount: this.searchBudget[0],
          spendingAmount: this.searchBudget[1]
        },
        orderBy: this.sortColumn,
        sort: this.sortType
      };
      this.$store
        .dispatch('budget/getBudgetDetailTaxo', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            let budgetTemp = [];
            for (let a = 0; a < data.data.taxonomy.length; a++) {
              if (data.data.taxonomy[a].name !== 'Couponing/Write offs') {
                budgetTemp.push(...data.data.taxonomy[a].listTaxonomy);
                // budgetTemp.push({
                //   id: data.data.taxonomy[a].id,
                //   desc: data.data.taxonomy[a].name,
                //   amountBudget: data.data.taxonomy[a].totalBudget,
                //   amountSpending: data.data.taxonomy[a].totalSpending,
                //   type: 'total'
                // });
              }
            }
            let indexCard = itemParent.indexCard;
            let idxGroup = indexGroup;
            let idxTab = indexTab;
            if (idxGroup >= 0) {
              // hapus group dibawahnya
              let listgroup = [];
              if (
                itemParent.filterBy === 'budgetOwner' ||
                this.isLoggedInAsBO
              ) {
                // if filter by bo atau login as bo slice 0
                listgroup = this.items[indexCard].group[idxTab].listGroup.slice(
                  0,
                  idxGroup
                );
              } else {
                // if filter by bo atau login as bo slice 1
                listgroup = this.items[indexCard].group[idxTab].listGroup.slice(
                  0,
                  idxGroup + 1
                );
              }
              this.items[indexCard].group[idxTab].listGroup = listgroup;
            }

            let budgetByTaxo = {
              listTaxo: budgetTemp,
              ...data.data,
              budgetMovement: [],
              historyBudget: [],
              name: 'Budget By Taxonomy',
              selected: [],
              groupActive: event.id,
              budgetCode: event.budgetCode,
              selectAll: false
            };
            this.items[indexCard].group[idxTab].listGroup.push(budgetByTaxo);
            this.getBudgetHistory(event, indexCard, idxTab);
            this.historyBudget(event, indexCard, idxTab);
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
        });
    },
    getBudgetHistory(item, indexCard, idxTab) {
      this.progressDialogLoading = true;
      let params = {
        budget_code: item.budgetCode
      };
      this.$store
        .dispatch('budgetMovement/history', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            let groupLength = this.items[indexCard].group[idxTab].listGroup
              .length;
            this.items[indexCard].group[idxTab].listGroup[
              groupLength - 1
            ].budgetMovement = data.data.historyLog;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
        });
    },
    historyBudget(item, indexCard, idxTab) {
      this.progressDialogLoading = true;
      let params = {
        budget_code: item.budgetCode
      };
      this.$store
        .dispatch('onePager/historyBudget', params)
        .then(data => {
          this.progressDialogLoading = false;
          if (data.code === 200) {
            let groupLength = this.items[indexCard].group[idxTab].listGroup
              .length;
            this.items[indexCard].group[idxTab].listGroup[
              groupLength - 1
            ].historyBudget = data.data.result;
          } else {
            Swal.fire('Failed!', data.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          Swal.fire('Failed!', err.data.message.text_en, 'error');
        });
    }
  }
};
</script>
